import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';

const RealisticIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="36.955"
      viewBox="0 0 30.411 36.955"
      y={props.yVal}
      x={props.xVal}
      fill={props.color}
      role="img"
    >
      <title>{t('Realistic Icon')}</title>
      <path
        d="M100.768,64.955h9.181a7.2,7.2,0,0,0,6.187-3.371l7.942-13.2-.448-.318-.025-.019a3.742,3.742,0,0,0-2.564-.8,3.677,3.677,0,0,0-2.461,1.126l-2.291,2.413a.722.722,0,0,1-.728.174.579.579,0,0,1-.435-.534l-.013-16.6a2.178,2.178,0,0,0-4.342-.079c0,1.677,0,3.5,0,5.239,0,3.929,0,7.32,0,7.648a.527.527,0,0,1-.191.4.706.706,0,0,1-.463.164h0a.707.707,0,0,1-.462-.162.528.528,0,0,1-.193-.4c0-.331,0-3.72,0-7.65,0-1.7,0-3.476,0-5.12,0-.013,0-.025,0-.039,0-.032,0-.063,0-.1v-3.7A2.109,2.109,0,0,0,107.288,28h-.067a2.122,2.122,0,0,0-2.191,2.038V46.649a.663.663,0,0,1-1.311,0V32.186a2.157,2.157,0,0,0-4.309,0V46.649a.663.663,0,0,1-1.311,0V38.124A2.109,2.109,0,0,0,95.906,36.1h-.063a2.1,2.1,0,0,0-2.171,2.026c-.012,4.659,0,12.873,0,20.226A6.869,6.869,0,0,0,100.768,64.955Z"
        transform="translate(-93.666 -28)"
      />
    </svg>
  );
};

export default RealisticIcon;

RealisticIcon.propTypes = {
  color: PropTypes.string.isRequired,
};
